import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useForm, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Form, Button, message, Alert } from 'antd';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { CheckOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import FormInput from '../components/global/Forms/FormInput';
import { forgotPassword } from '../actions/user';
import LoginFooter from './LoginFooter';
import emailImage from '../../images/icons/register-email.svg';

const ForgotPasswordPage: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState<string>('');

  const validationSchema = Yup.object().shape({
    email: Yup.string().email().required(t('validation:required')),
  });

  const formMethods = useForm({
    defaultValues: {
      email: '',
    },
    resolver: yupResolver(validationSchema),
    mode: 'onTouched',
  });

  const { handleSubmit, formState } = formMethods;

  const onSubmit = async (values: { email: string }) => {
    setError('');
    try {
      await dispatch(forgotPassword(values.email));
      message.success(t('login:passwordEmailSuccess'));
      setSubmitted(true);
    } catch {
      setError(t('login:passwordEmailFailed'));
    }
  };

  return (
    <div className="login__background">
      <div className="login__box">
        <div className="login__box-header">
          <div className="login-logo" />
        </div>
        <div className="login__box-content">
          {submitted && (
            <div className="login--header-content">
              <img src={emailImage} alt={t('common:email')} />

              <div className="login__title">{t('login:resetPassword')}</div>
              <div className="mt-2">{t('login:emailSent')}</div>
            </div>
          )}

          {!submitted && (
            <React.Fragment>
              <div className="login--header-content">
                <div className="login__title">{t('login:resetPassword')}</div>
                <div className="mt-2">{t('login:resetPasswordInfo')}</div>
              </div>

              <FormProvider {...formMethods}>
                <Form layout="vertical" onFinish={handleSubmit(onSubmit)}>
                  <FormInput
                    name="email"
                    label={t('common:email')}
                    placeholder={t('common:email')}
                    disabled={submitted}
                    size="large"
                    required
                    useHookForm
                  />

                  {error && (
                    <Alert type="error" showIcon message={error} style={{ marginBottom: 20 }} />
                  )}

                  <Button
                    type="primary"
                    htmlType="submit"
                    disabled={!formState.isValid || formState.isSubmitting || submitted}
                    loading={formState.isSubmitting}
                    icon={submitted ? <CheckOutlined /> : undefined}
                    style={{ width: '100%', marginTop: 15, marginBottom: 10 }}
                    size="large"
                  >
                    {t('login:confirmResetPassword')}
                  </Button>
                </Form>
              </FormProvider>
              <div className="text-center mt-5">
                <Link className="register__login-text" to="/">
                  {t('login:backToLogin')}
                </Link>
              </div>
            </React.Fragment>
          )}
        </div>
      </div>

      <LoginFooter />
    </div>
  );
};

export default ForgotPasswordPage;
